import { useTranslation } from 'react-i18next';

import { useErrorMessage } from '@nucleus-commerce/admin-kit/errors';
import { isApiError } from '@nucleus-commerce/api-client/transport';

/** The user-facing message for a failed save, with the request id support asks for. */
export function useServerMessage() {
  const { t } = useTranslation('errors');
  const message = useErrorMessage();
  return (error: unknown): string => {
    const text = message(error);
    const requestId = isApiError(error) ? error.requestId : undefined;
    return requestId ? `${text} ${t('requestIdShort', { requestId })}` : text;
  };
}
